import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const XML_EXPORT_QUERY = gql`
  query xmlExport($documentVersion: DocumentVersionInput!, $type: FileExportType!, $variation: String) {
    xmlExport(documentVersion: $documentVersion, type: $type, variation: $variation) {
      url
      message
      status
      type
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class XmlExportQuery extends Query<RootQuery> {
  document = XML_EXPORT_QUERY;
}
